module.exports = __webpack_public_path__ + "img/SNB_Premuim.5ab173c6.svg";